import { createApiRef } from '@backstage/core-plugin-api';
import { TechTalkApi } from './types';
import { ContributeApi } from './contributeTypes';

export const techTalkApiRef = createApiRef<TechTalkApi>({
  id: 'plugin.tech-talk.service',
});

// GitLab project lookup used by the /contribuer page's project path
export const contributeApiRef = createApiRef<ContributeApi>({
  id: 'plugin.tech-talk.contribute',
});

export * from './types';
export * from './contributeTypes';
export { TechTalkClient } from './TechTalkClient';
export { ContributeClient } from './ContributeClient';
